/**
 * 
 * Supplemental file for Favorites customizations in order to assist in upgrade paths.
 *
 */
define('modules/Favorites/FavoritesBulkAddToCart',[
    'lodash',
    'jquery',
    'global/all',
    './FavoritesManager',
    'modules/Cart/CartManager',
    'modules/Cart/CartLocker'
], function (_, $, Roc, FavoritesManager, CartManager, CartLocker) {
    'use strict';

    var listId = null;

    var apiUrl = window.RocConfig.api.baseRocApiUrl;

    var maximumQty = 999999;

    var itemsToAdd = [];

    var selectors = {
        addSelectedItemsToFavorites: 'button[data-roc-action="addSelectedItemsToFavorites"]',
        addSelectedItemsQty: '.itemAction input.addQty',
        getItemQtyField: getItemQtyField
    }

    function getItemQtyField(productId, uomId) {
        return $(".itemWrapper[data-product-id='" + productId + "'][data-uom-id='" + uomId + "']")
            .find(selectors.addSelectedItemsQty);
    }

    function updateAddToCartButtonLabel() {
        var itemsSelected = _.filter(itemsToAdd,
            function (itemToAdd) {
                return itemToAdd.quantity > 0;
            });

        var btnLabel;
        var isDisabled = false;
        switch (itemsSelected.length) {
            case 0:
                btnLabel = 'Add Selected Items To Cart';
                isDisabled = true;
                break;
            case 1:
                btnLabel = 'Add Selected Item (1) To Cart';
                break;
            default:
                btnLabel = 'Add Selected Items (' + itemsSelected.length + ') To Cart';
                break;
        }

        var $btns = $(selectors.addSelectedItemsToFavorites);
        $btns.text(btnLabel);
        $btns.attr('disabled', isDisabled);
    }

    function addToCartItemQtyChangeEvt() {
        Roc.UI.siteBody
            .off('change', selectors.addSelectedItemsQty)
            .on('change', selectors.addSelectedItemsQty, function (e) {
                validateQtyAndAddToSelectedItems(this);
                updateAddToCartButtonLabel();
            });

    }

    function addSelectedItemsToFavoritesEvt() {
        Roc.UI.siteBody
            .off('click', selectors.addSelectedItemsToFavorites)
            .on('click', selectors.addSelectedItemsToFavorites, function (e) {
                e.preventDefault();
                Roc.Core.lockButton(selectors.addSelectedItemsToFavorites);
                itemsToAdd = _.filter(itemsToAdd,
                    function (itemToAdd) {
                        return itemToAdd.quantity > 0;
                    });

                if (itemsToAdd.length === 0) {
                    return;
                }

                var message = 'Do you want to add below item';
                message += itemsToAdd.length === 1 ? ' ' : 's ';
                message += 'to your cart?<br /><ul>';
                for (var i in itemsToAdd) {
                    if (!itemsToAdd.hasOwnProperty(i)) {
                        continue;
                    }                    
                    message += '<li>' + itemsToAdd[i].productName;
                    if (itemsToAdd[i].uomId) {
                        message += ' (UoM: ' + itemsToAdd[i].uomId + ')';
                    }
                    message += ', Qty: ' + itemsToAdd[i].quantity;
                    message += '</li>';

                }
                message += '</ul>';

                Roc.UI.confirm({
                    "title": 'Add To Cart',
                    "message": message,
                    "buttons": {
                        "Add &amp; Continue": {
                            "class": 'btn btnAction btnConfirmAddToCartFavItems',
                            "autoClose": false,
                            "action": function () {
                                addItemsToCart(false);
                            }
                        },
                        "Add &amp; Checkout": {
                            "class": 'btn btnAction btnConfirmAddToCartFavItems',
                            "autoClose": false,
                            "action": function () {
                                addItemsToCart(true);
                            }
                        },
                        "Cancel": {
                            "class": 'btn btnCloseConfirmAddToCartFavItems',
                            "action": function () {
                                Roc.Core.releaseLockedButton(selectors.addSelectedItemsToFavorites);
                            }
                        }

                    }
                });
            });
    }

    function addItemsToCart(redirectToCart) {            
        Roc.Core.lockButton('.btnConfirmAddToCartFavItems');

        CartLocker.isCartUnlocked()
            .then(function () {
                CartManager.bulkAddToCart(itemsToAdd, true)
                    .then(function (response) {
                        redirectToCart = redirectToCart && response.orderId && filterOutMessagesForDisplay(response);
                        if (redirectToCart) {
                            itemsToAdd = [];
                            window.location.href = '/cart';
                        } else {
                            itemsToAdd = [];
                            Roc.EventManager.notify(Roc.Events.favorites.UPDATE_LIST, null);
                            $('.btnCloseConfirmAddToCartFavItems').trigger('click');
                            if (response.messages > 0) {
                                var model = {};
                                model.heading =
                                    'Problems occurred during your request and we were not able to load one or more items to your cart.';
                                model.responses = response.addedItems;
                                Roc.UI.template('#serviceErrors-Tmp', model).then(function (renderedTemplate) {
                                    Roc.UI.Modal.open(renderedTemplate);
                                });
                            }
                        }
                    }).always(function () {
                        Roc.Core.releaseLockedButton('.btnConfirmAddToCartFavItems');                     
                    });
            });
    }
    function validateQtyAndAddToSelectedItems(qtySelector) {
        var qtyValue = $(qtySelector).val();
        var currentQty = $(qtySelector).data("rocCurrentQty");

        var currentValue = parseInt(qtyValue);

        if (isNaN(currentValue) || currentValue < 0 || currentValue > maximumQty) {
            Roc.UI.displayErrorPopup('There appears to be a problem with your quantity. Please try again and enter a valid quantity.');
            $(qtySelector).val(currentQty);
            return;
        }
        $(qtySelector).data("rocCurrentQty", qtyValue);

        // copy selected item to array
        var $wrapper = $(qtySelector).closest('.itemWrapper');

        var itemData = $wrapper.data();

        var upchargeDictionary = _.object(_.map(itemData.upcharges, function (upcharge) {
            var upchargeData = {
                code: upcharge.Code,
                upchargeAmount: upcharge.UpchargeAmount,
                json: upcharge.Data
            }
            return [upcharge.Code, upchargeData];
        }));

        var existedItem = getSelectedItem(itemData);

        if (existedItem && currentValue === 0) {
            removeItem(existedItem);
        } else if (existedItem && currentValue !== 0) {
            existedItem.quantity = isNaN(currentValue) ? 1 : Math.max(1, currentValue);
        } else {
            itemsToAdd.push({
                productId: itemData.productId,
                productName: itemData.productName,
                uomId: itemData.uomId,
                quantity: isNaN(currentValue) ? 1 : Math.max(1, currentValue),
                upchargeData: upchargeDictionary
            });
        }
    }

    function getSelectedItem(itemData) {
        return _.find(itemsToAdd,
            function (itemToAdd) {
                return itemToAdd.productId === itemData.productId &&
                    itemToAdd.uomId === itemData.uomId; // ignore upchares - we do not use them in sfreedman
            });
    };
    function removeItem(existedItem) {
        itemsToAdd = _.without(itemsToAdd, existedItem);
    };
    function reloadQuantities() {
        _.each(itemsToAdd,
            function (itemToAdd) {
                var $qty = selectors.getItemQtyField(itemToAdd.productId, itemToAdd.uomId);
                $qty.val(itemToAdd.quantity);
            });
        updateAddToCartButtonLabel();
    }

    function filterOutMessagesForDisplay(response) {
        var errors = 0;
        _.each(response.addCartItemsResponse, function (response) {
            response.errors = response.errors || [];
            errors += response.errors.length;
        });
        response.messages = errors;
        return errors === 0;
    }

    function onDeleteItemEvt(deletedItem) {
        if (deletedItem.Result === true) {
            var existedItem = getSelectedItem(deletedItem);
            removeItem(existedItem);
            reloadQuantities();
        }
    }

    function onMoveItemEvt(movedItem) {
        if (movedItem.Result === true) {
            var existedItem = getSelectedItem(movedItem);
            removeItem(existedItem);
            reloadQuantities();
        }
    }
    function bindEvents() {
        addToCartItemQtyChangeEvt();
        addSelectedItemsToFavoritesEvt();
        Roc.EventManager.bind(Roc.Events.favorites.MOVE_ITEM, onMoveItemEvt);
        Roc.EventManager.bind(Roc.Events.favorites.DELETE_ITEM, onDeleteItemEvt);
    }

    function init() {
        bindEvents();
    }

    var FavoritesBulkAddToCart = {
        init: init,
        reloadQuantities: reloadQuantities
    };

    Roc.Logger.debug('FavoritesBulkAddToCart.js Loaded:', FavoritesBulkAddToCart);

    return FavoritesBulkAddToCart;
});
